export default __webpack_public_path__ + "static/media/icon-table-hydraulics.68d8f274.svg";